import React from 'react';
import Button from '@/components/Button';

export default function MisionVisionContentModal({ content, onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 px-4 py-8"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 md:p-8 rounded-lg shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto m-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-3xl font-bold mb-6 text-blue-800 text-center">{content.title}</h2>
        
        <div className="space-y-6">
          <div>
            <h3 className="text-2xl font-semibold mb-3 text-blue-700 border-b-2 border-blue-200 pb-2">Misión</h3>
            <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">{content.mission}</p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-3 text-blue-700 border-b-2 border-blue-200 pb-2">Visión</h3>
            <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">{content.vision}</p>
          </div>
        </div>

        <div className="text-right mt-8">
          <Button 
            onClick={onClose} 
            variant="default"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-lg transition-colors"
          >
            Cerrar
          </Button>
        </div>
      </div>
    </div>
  );
}
